import { useTranslation } from 'react-i18next';
import { Alert } from '@c2fo/liquidity';
import { useReporting } from '@/reporting';

const appDomain = (import.meta.env.VITE_LOGIN_URL ?? '').replace('/login', '');

/**
 * The literal pre-personalization static FinanceIQ promo — the plain Liquidity `Alert` that lived
 * directly in InvoiceCentralLayout.tsx before the KPI spotlight banner existed. Deliberately NOT
 * built on KpiSpotlightBannerShell or any other new-design code: it's the `enterprise-ui_enableKpiSpotlightBanner`
 * flag's OFF path, so a problem in the new banner (or its shared shell) can be rolled back to this
 * without carrying any of the same risk.
 */
const LegacyFinanceIqAlert = () => {
  const { t } = useTranslation();
  const { trackEnterpriseEvent } = useReporting();

  return (
    <Alert
      type="info"
      title={t('invoiceCentral.financeIq.title')}
      description={t('invoiceCentral.financeIq.description')}
      action={{
        text: t('invoiceCentral.financeIq.legacyAction'),
        onClick: () => {
          trackEnterpriseEvent('invoice-central::finance-iq-navigation::clicked');
          window.open(
            `${appDomain}/financeiq/?utm_partner=&utm_lang=en_US&utm_source=c2fo&utm_medium=in_app&utm_region=amer&utm_lifecycle=cross&utm_audience=na&utm_campaign=financeiq&utm_series=invoicecentral426&utm_country=us&utm_content=&utm_term=`,
            '_blank',
            'noreferrer'
          );
        },
      }}
      full
    />
  );
};

export default LegacyFinanceIqAlert;
